import { createContext, useContext, useEffect, useState } from "react";
import { translations, languageMeta } from "../lib/i18n";

const LanguageContext = createContext(null);
const AVAILABLE = new Set(languageMeta.map((l) => l.code));

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const stored = localStorage.getItem("chalet_lang");
    if (stored && AVAILABLE.has(stored)) return stored;
    // Try browser language auto-detect (first match wins), default to German
    const nav = (navigator.language || "de").slice(0, 2).toLowerCase();
    return AVAILABLE.has(nav) ? nav : "de";
  });
  useEffect(() => { localStorage.setItem("chalet_lang", lang); document.documentElement.lang = lang; }, [lang]);
  const t = translations[lang] || translations.de;
  const toggle = () => setLang((p) => (p === "de" ? "en" : "de"));
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, languages: languageMeta }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be inside LanguageProvider");
  return ctx;
};
